import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enviam-storungen',
  templateUrl: './enviam-storungen.component.html',
  styleUrls: ['./enviam-storungen.component.scss'],
})
export class EnviamStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;

  constructor(private _router: Router) {}

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
